import { FC } from 'react'
import { IArpMedia } from '../../arp-registry/ArpMedia'
import { useRemixArpMedia } from '../../arp-utils'
import { RecentEmpty } from '../primitives'
import { RecentLoader } from './RecentLoader'

export const ArpRecentActivityEmptyState: FC<{ media: IArpMedia }> = ({ media }) => {
  const { remix, status } = useRemixArpMedia(media)
  if (status === 'loading') return <RecentLoader />
  return (
    <RecentEmpty.Root onClick={remix}>
      <RecentEmpty.Icon />
      <RecentEmpty.Title>Be the first to remix or like this song!</RecentEmpty.Title>
      <RecentEmpty.Action>Open in Studio</RecentEmpty.Action>
    </RecentEmpty.Root>
  )
}
